import styled from 'styled-components';
import FormattedNumber from 'I18n/components/FormattedNumber';
import isNumber from 'transmute/isNumber';
import { Flex } from 'foundations-components/components/Flex';
import { Spacer } from 'foundations-components/components/Spacer';
import { View } from 'foundations-components/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const StyledCollapsedColumnContent = styled.div.withConfig({
  displayName: "CollapsedColumnContentV2__StyledCollapsedColumnContent",
  componentId: "sc-1x07hgb-0"
})(({
  theme
}) => `
  writing-mode: vertical-rl;
  white-space: nowrap;
  font-size: ${theme.typography['heading-25'].fontSize};
  font-weight: ${theme.typography['heading-25'].fontWeight};
  letter-spacing: ${theme.typography['heading-25'].letterSpacing};
  font-family: ${theme.typography['heading-25'].fontFamily};
  display: flex;
  align-items: center;
  justify-content: flex-start;
  height: 100%;
  width: 100%;
  `);
export const CollapsedColumnContentV2 = ({
  columnData
}) => {
  const {
    totalCards
  } = columnData;
  return /*#__PURE__*/_jsx(StyledCollapsedColumnContent, {
    "data-test-id": "cdb-column-collapsed-content",
    children: /*#__PURE__*/_jsxs(Flex, {
      flexDirection: "row",
      justifyContent: "center",
      children: [/*#__PURE__*/_jsx(View, {
        children: columnData.name
      }), /*#__PURE__*/_jsx(Spacer, {
        display: "inline-block",
        space: "200"
      }), isNumber(totalCards) && /*#__PURE__*/_jsx(FormattedNumber, {
        value: totalCards
      })]
    })
  });
};